import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { IMAGE_TOOL, TOOLS } from "@/components/tools/toolsConfig";
import { ToolPanel } from "@/components/tools/ToolPanel";
import { ImageToolPanel } from "@/components/tools/ImageToolPanel";
import { Reveal } from "@/components/landing/Reveal";

const ALL = [...TOOLS, IMAGE_TOOL];

export const AiTools = () => (
  <section id="herramientas" className="relative bg-white">
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-28">
      <Reveal className="max-w-2xl">
        <p className="text-xs font-semibold uppercase tracking-wider text-[#E05A47]">Herramientas IA gratis</p>
        <h2 className="mt-3 text-3xl font-bold tracking-tight text-[#1E1A17] sm:text-4xl">Pruébalo ahora: tu marketing hecho en segundos</h2>
        <p className="mt-4 text-base text-[#6E655F] md:text-lg">Elige una herramienta, cuéntanos de tu negocio y mira cómo la IA crea textos e imágenes por ti.</p>
      </Reveal>
      <Tabs defaultValue={TOOLS[0].id} className="mt-12">
        <TabsList className="mb-8 h-auto w-full flex-wrap justify-start gap-2 bg-transparent p-0 sm:w-auto">
          {ALL.map((t) => (
            <TabsTrigger key={t.id} value={t.id} data-testid={`tool-tab-${t.id}`}
              className="rounded-full border border-[#E8E1D7] bg-[#FAF7F2] px-5 py-2.5 text-sm font-semibold data-[state=active]:border-[#1E1A17] data-[state=active]:bg-[#1E1A17] data-[state=active]:text-white">
              {t.label}
              {t.id === IMAGE_TOOL.id && <span className="ml-2 rounded-full bg-[#E05A47] px-2 py-0.5 text-[10px] font-bold uppercase text-white">Nuevo</span>}
            </TabsTrigger>
          ))}
        </TabsList>
        {TOOLS.map((t) => (
          <TabsContent key={t.id} value={t.id}><ToolPanel tool={t} /></TabsContent>
        ))}
        <TabsContent value={IMAGE_TOOL.id}><ImageToolPanel tool={IMAGE_TOOL} /></TabsContent>
      </Tabs>
    </div>
  </section>
);
